import React, { useEffect, useState } from 'react';
import { ModalBody } from '../modal/Modal';
import { useModal } from '../modal/useModal';
import { ViewType } from './FileType';
import './FileViewer.css'
import { FixedSizeGrid as Grid } from 'react-window';

/* eslint-disable */

function ImageViewer(props: {
    name?: string
    src?: string
}) {
    return (
        <img src={props.src} alt={props.name} style={{ maxHeight: 'calc(80vh - 2rem)', maxWidth: 'calc(90vw - 2rem)' }} />
    )
}

function TextViewer(props: {
    children?: string
}) {
    const jsx: JSX.Element[] = [];
    if (props.children) {
        const lines = props.children.split(/;/g);

        for (let i = 0; i < lines.length; ++i) {
            jsx.push(
                <span key={i * 2}>{lines[i]}</span>
            )
            jsx.push(
                <br key={i * 2 + 1} />
            )
        }
    }

    return (
        <div>
            {jsx}
        </div>
    )
}

function getClientHeight() {
    var clientHeight = 0;
    if (document.body.clientHeight && document.documentElement.clientHeight) {
        var clientHeight = (document.body.clientHeight < document.documentElement.clientHeight) ? document.body.clientHeight : document.documentElement.clientHeight;
    }
    else {
        var clientHeight = (document.body.clientHeight > document.documentElement.clientHeight) ? document.body.clientHeight : document.documentElement.clientHeight;
    }
    return clientHeight;
}


function CSVViewer(props: {
    children?: string
}) {
    if (!props.children) return <></>;
    const lines = props.children.split(/;/g);
    const dataArray: string[][] = [];
    lines.forEach(line => {
        const lineArray = line.split(/,/g);
        dataArray.push(lineArray);
    });
    const [height, setHeight] = useState(getClientHeight() - 170);

    useEffect(() => {
        const handleResize = () => {
            setHeight(getClientHeight() - 170);
        }
        window.addEventListener('resize', handleResize);
        return ()=>{
            window.removeEventListener('resize', handleResize);
        }
    }, [])

    const Cell = ({ columnIndex, rowIndex, style }: {
        columnIndex: number,
        rowIndex: number,
        style: React.CSSProperties,
    }) => (
        <div
            className={
                columnIndex % 2
                    ? rowIndex % 2 === 0
                        ? 'GridItemOdd'
                        : 'GridItemEven'
                    : rowIndex % 2
                        ? 'GridItemOdd'
                        : 'GridItemEven'
            }
            style={{
                ...style,
                fontWeight: rowIndex === 0 ? 'bold' : 'normal',
                fontSize: rowIndex === 0 ? 16 : 14,
                background: rowIndex % 2 ? '' : '#f0f2f9',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            }}
        >
            {dataArray[rowIndex][columnIndex]}
        </div>
    );
    return <Grid
        className="Grid"
        columnCount={dataArray[0].length}
        columnWidth={160}
        height={height}
        rowCount={dataArray.length}
        rowHeight={50}
        width={160 * dataArray[0].length + 20}
    >
        {Cell}
    </Grid>
}

export default function FileViewer(props: {
    type: ViewType
    name?: string
    src?: string
    children?: string
}) {
    let jsx: JSX.Element = <></>
    switch (props.type) {
        case ViewType.IMAGE:
            jsx = <ImageViewer name={props.name} src={props.src} />;
            break;
        case ViewType.TEXT:
            jsx = <TextViewer>{props.children}</TextViewer>;
            break;
        case ViewType.CSV:
            jsx = <CSVViewer>{props.children}</CSVViewer>;
            break;
        default:
            break
    }
    return jsx
}

export function FetchFileViewer(props: {
    fetch: () => Promise<string>
    type: ViewType
    name?: string,
}) {
    const [contents, setContents] = useState("");
    useEffect(() => {
        setContents("");
        props.fetch().then(setContents);
    }, [props.fetch, props.type]); // eslint-disable-line

    return (
        <>
            {!contents ?
                <div className="text-center">
                    <div className="spinner-border text-primary" role="status">
                        <span className="sr-only">Loading...</span>
                    </div>
                </div> :
                <FileViewer type={props.type} src={contents}>{contents}</FileViewer>}
        </>
    )
}

export function useFileViewer(): [(name: string, type: ViewType, contents: string) => void, JSX.Element] {
    const [create, jsx] = useModal();

    function show(name: string, type: ViewType, contents: string) {
        create(
            <ModalBody>
                <FileViewer type={type} name={name} src={contents}>{contents}</FileViewer>
            </ModalBody >
            , name);

    }

    return [show, jsx];
}

export function useFetchFileViewer(): [(name: string, type: ViewType, fetch: () => Promise<string>) => void, JSX.Element] {
    const [create, jsx] = useModal();

    function show(name: string, type: ViewType, fetch: () => Promise<string>) {
        create(
            <ModalBody>
                <FetchFileViewer type={type} fetch={fetch} name={name} />
            </ModalBody >
            , name);

    }
    return [show, jsx];
}


export interface IImage {
    filename: string,
    src: string,
}


function CarouselFileViewer(props: {
    images: IImage[],
    default?: number,
    setTitle: (title: string) => void
}) {
    const [index, setIndex] = useState(props.default ? props.default : 0);

    if (props.images.length < 0) {
        return (<></>)
    }

    return (
        <ModalBody>
            <div className="viewerContent">
                <FileViewer type={ViewType.IMAGE} name={props.images[index].filename} src={props.images[index].src}>{props.images[index].src}</FileViewer>
            </div>
            <>
                {index <= 0 ? <></> :
                    <a className="carousel-control-prev" role="button" data-slide="prev" onClick={() => {
                        setIndex(index - 1);
                        props.setTitle(props.images[index - 1].filename);
                    }}>
                        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                        <span className="sr-only">Previous</span>
                    </a>
                }

            </>
            <>
                {index >= props.images.length - 1 ? <></> :
                    <a className="carousel-control-next" role="button" data-slide="next" onClick={() => {
                        setIndex(index + 1);
                        props.setTitle(props.images[index + 1].filename);
                    }}>
                        <span className="carousel-control-next-icon" aria-hidden="true"></span>
                        <span className="sr-only">Next</span>
                    </a>
                }
            </>
        </ModalBody >
    )
}

export function useCarouselFileViewer(
    images: IImage[]
): [(indexStart: number) => void, JSX.Element] {
    const [create, jsx, , setTitle] = useModal();
    function show(indexStart: number) {
        create(<CarouselFileViewer setTitle={setTitle} images={images} default={indexStart} />, images[indexStart].filename);

    }

    return [show, jsx];
}

/* eslint-enable */